import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import GuardianAccount from './GuardianAccount';
import PaymentPlan from './PaymentPlan';
import DeleteAccount from './DeleteAccount';
import DashboardHeader from '../../header/DashboardHeader';
import { bg } from '../../../constants/component.constants';
import { changeBodyClassName } from '../../../utils/utils';

import './css/guardian.settings.overview.scss';
import GuardianEditProfile from './GuardianEditProfile';

const GuardianDetails = () => {
  useEffect(() => {
    changeBodyClassName([bg.WHITE]);
  }, []);

  return (
    <div className="guardian-setting-wrapper" id="guardian_setting_img">
      <DashboardHeader />
      <Container fluid="md" className='guardian-details-bg'>
        <GuardianAccount />
        <GuardianEditProfile />
        <PaymentPlan />
        <DeleteAccount />
      </Container>
    </div>
  );
};

export default GuardianDetails;
